<div class="evee-root">
  <div class="evee-panel" *ngIf="open">
    <div class="evee-head">
      <div class="evee-avatar">
        <img src="/assets/evee/evee-icon.png" alt="Evee" />
      </div>
      <div>
        <div class="evee-name">Evee</div>
        <div class="evee-status">
          {{ evee.listening ? 'Listening…' : (evee.speaking ? 'Speaking…' : 'PredictScreen assistant') }}
        </div>
      </div>
      <button type="button" class="evee-close" (click)="togglePanel()" aria-label="Close">&times;</button>
    </div>

    <div class="evee-thread" #thread>
      <div class="evee-msg" *ngFor="let msg of evee.messages" [class.evee-msg-user]="msg.from === 'user'">
        {{ msg.text }}
      </div>
    </div>

    <div class="evee-picker" *ngIf="evee.awaitingSubscriber">
      <input class="form-control form-control-sm" type="text" placeholder="Search subscriber"
        [(ngModel)]="pickerFilter" [ngModelOptions]="{standalone: true}" />
      <button type="button" class="evee-choice" *ngFor="let user of filteredSubscribers()" (click)="pick(user)">
        {{ user.companyName }}
        <small *ngIf="user.dvID">DV {{ user.dvID }}</small>
      </button>
      <div class="evee-empty" *ngIf="filteredSubscribers().length === 0">No subscribers match that name.</div>
    </div>

    <div class="evee-chips">
      <button type="button" *ngFor="let tip of suggestionList()" (click)="useSuggestion(tip)">{{ tip }}</button>
    </div>

    <form class="evee-input" (ngSubmit)="sendTyped()">
      <input type="text" [(ngModel)]="typedText" name="eveeText" placeholder="Talk to Evee or type here"
        autocomplete="off" />
      <button type="button" class="evee-mic" [class.live]="evee.listening" (click)="toggleMic()" aria-label="Voice">
        <img src="/assets/evee/evee-icon.png" alt="Voice" />
      </button>
      <button type="submit" class="evee-send" aria-label="Send">
        <em class="fas fa-paper-plane"></em>
      </button>
    </form>
  </div>

  <button type="button" class="evee-fab" (click)="togglePanel()" [class.open]="open" aria-label="Evee assistant">
    <img src="/assets/evee/evee-icon.png" alt="Evee" />
  </button>
</div>
